import { getCardsPool } from "../shared/cards-pool.js";
import { loadDeck } from "./storage.js";
import { renderMiniCard } from "./card-render.js";

const SUIT_ORDER = ["action", "observation", "relation"];

export async function mountDeck(rootEl) {
  const cards = await getCardsPool();
  rootEl.innerHTML = `
    <section class="deck-section">
      <header class="section-head">
        <h3 class="section-title">Your deck</h3>
        <span class="section-count"><span id="deck-num">0</span> kinds</span>
      </header>
      <div id="deck-grid" class="deck-grid"></div>
    </section>
  `;
  const elNum = rootEl.querySelector("#deck-num");
  const elGrid = rootEl.querySelector("#deck-grid");

  function render() {
    const deck = loadDeck();
    const flat = [];
    SUIT_ORDER.forEach((suit) => {
      Object.keys(deck[suit] || {}).forEach((idx) => {
        const i = parseInt(idx, 10);
        const count = deck[suit][i];
        if (count > 0) flat.push({ suit, index: i, card: cards[suit][i], count });
      });
    });
    elNum.textContent = flat.length.toString();
    if (flat.length === 0) {
      elGrid.innerHTML = '<div class="empty">You haven\'t opened any packs yet.</div>';
      return;
    }
    elGrid.innerHTML = "";
    flat.sort((a, b) => SUIT_ORDER.indexOf(a.suit) - SUIT_ORDER.indexOf(b.suit) || a.card.n.localeCompare(b.card.n));
    for (const item of flat) {
      const el = renderMiniCard({ ...item.card, suit: item.suit });
      el.title = item.card.d;
      if (item.count > 1) {
        const dupe = document.createElement("span");
        dupe.className = "tc-mini-dupe";
        dupe.textContent = `×${item.count}`;
        el.appendChild(dupe);
      }
      elGrid.appendChild(el);
    }
  }

  return { render };
}
